import React from 'react';
import { Text } from './Text';
import { Button } from './Text';
import Card from './Card';
import enUS from '../tokens/en-US.json';
import esES from '../tokens/es-ES.json';
import jpJP from '../tokens/jp-JP.json';
import ptBR from '../tokens/pt-BR.json';
import { TransferMarriott } from './TransferMarriott';
import transferMilesIcon from '../assets/icons/transfer_miles_teal.svg';
import requestMilesBlueIcon from '../assets/icons/request_miles_teal.svg';

import transferMilesThumbnail from '../assets/thumbnail/transfer-miles-united.png';
import requestMilesThumbnail from '../assets/thumbnail/request-transfer-miles-united.png';


export const translations = {
    'en-US': enUS,
    'es-ES': esES,
    'jp-JP': jpJP,
    'pt-BR': ptBR,
};
export const Transfer = ({ languageCode, toggleHiddenRequestTransfer }) => (
    <div className="main-item transfer clearfix" id="transfer">
        <div className="main-item-container">
            <div className="main-item_content">
                <h3><Text languageCode={languageCode} token="transfer.subheader" /></h3>
                <h2 className="transfer-header"><Text languageCode={languageCode} token="transfer.header" /></h2>
                <h4><Text languageCode={languageCode} token="transfer.text" /></h4>

                <div className="main-item_cards">
                    {/* Card 1 - Transfer Miles */}
                    <Card
                        buyMilesIcon={transferMilesThumbnail} // Corrected: Added buyMilesIcon
                        title="transfer.button.yourself"
                        description="transfer.tooltip.yourself"
                        buttonText="transfer.button.yourself"
                        url="transfer.link.url"
                        languageCode={languageCode}
                        buttonClassName="transfer-link-pcta"
                        buttonId="transfer-cta-button"
                        promoToken="transfer.onsale.token"
                    />

                    {/* Card 2 - Request Miles */}
                    <Card
                        buyMilesIcon={requestMilesThumbnail} 
                        title="transfer.button.another"
                        description="trasnfer.tooltip.another"
                        buttonText="transfer.button.another"
                        url="transfer.another.link.url"
                        languageCode={languageCode}
                        buttonClassName="request-transfer-link-pcta"
                        buttonId="request-transfer-cta-button"
                        promoToken="reinstate.onsale.token"
                    />
                </div>

                <p><Text languageCode={languageCode} token="transfer.disclaimer1" /></p>
                <p><Text languageCode={languageCode} token="transfer.disclaimer2" /></p>

            </div>
        </div>


    </div>

);
